/**
 * Get the value or return a default value.
 * @param {*} value any value
 * @param {*} defaultValue the default value.
 * @return {*} value or default value.
 */
export function getOrDefault(value, defaultValue) {
  return value ? value : defaultValue;
}
